import { IUnit } from "./units";

export enum QuestSkillType {
  Strength,
  Dexterity,
  Willpower,
  Feat
}

export interface IQuestUnit extends IUnit {
  baseTough: number;
}

export interface IQuestSkill {
  id: string;
  name: string;
  sqName: string;
  rule: string;
  type: QuestSkillType;
  tier: number;
  classId?: string;
  costFormula: any[];
}

export interface IQuestConsumable {
  id: string;
  name: string;
  sqName: string;
  baseName?: string;
  tier: number;
  description: string;
  costFormula: any[];
}

export interface IQuestRule {
  id: string;
  name: string;
  sqName?: string;
  baseName?: string;
  description: string;
  sqDescription?: string;
}

export interface IQuestInjury extends IQuestRule {}
export interface IQuestClass extends IQuestRule {}

export enum QuestGameType {
  Solo,
  Host,
  Join
}

export type MissionMapItem = {
  type: MapItemType;
} & MapItemLocation;

export enum MapItemType {
  HeroDeploy,
  EnemyDeploy,
  SearchToken,
  Objective
}

export enum MapItemLocations {
  TableCenter,
  QuarterCenter,
  QuarterCorner
}

export type MapItemLocation = {
  location: MapItemLocations;
  quarterIndex?: number;
};
